import { createMuiTheme } from "@material-ui/core/styles";

const defaultThemeStyles = {
  textFontSize: 12,
  headerTextFontSize: 14,
  headerTextFontSize16: 16,
  dispatchCardTextFontSize: 10,
  trailerExtraBillsColor: "#F3A628",
  warningColor: "#E5A70D",
  delayedStopMarkerColor: "#F22929",
  statusWrapperHighlightedColor: "#F8D9D9",
  error: "#CF0000",
  white: "#FFFFFF",
  deviationStopColor: "#FC8596",
  selectedStopMarkerColor: "#FFFFFF",
  stopNameColor: "#1885FF",
  proNumberColor: "#30A3A0",
  deviationGreenPopupColor: "#CDEDE9",
  driverReportFilterBGColor: "#F8F8F8",
  satelliteViewRouteColor: "#FFFFFF",
  radioLabel: "#EAF6F5",
  radioLabelText: "#227270",
  activeRadioBG: "#C1E3E3",
  checkboxColor: "#7EC3C1",
  dispatchShipperTextColor : "#30A3A0",
  endTripIconActive: "#CF0000",
  missedPickupIcon: "#D54040",
  emptyTrailerBorder:"#808080",
  hazmatSubheader: "#599AE5",
  notificationLinkColor: "#44A8EE",
  shadowColor: "rgba(0, 0, 0, 0.25)",
  violationsBackgroundColor: "#CF00001A",
  loaderBgColorTranslucent:"rgba(128, 128, 128, 0.2)",
  quickFilterFooterBGColor : "rgb(0,0,0,0.04)",
  primaryBoxShadow:"rgba(5, 167, 146, 0.16)",
  overrides: {
    MuiSvgIcon: {
      root: {
        fontSize: 16,
      },
    },
    MuiButton: {
      root: {
        textTransform: "none",
      },
    },
    MuiSnackbarContent: {
      message: {
        fontWeight: 600,
      },
    },
  },
};

/* Grid theme colors are placed in DataGrid -> styles.scss */
export const lightTheme = createMuiTheme({
  ...defaultThemeStyles,
  themeName: "light",
  AppBGColor: "#D9D9D9",
  HeaderBGColor: "#333333",
  HeaderSelectedText: "#05A792", // Also used for tab indicator
  HeaderDefaultTextColor: "#CCCCCC",
  ColumnHeaderTextColor: "#4D4D4D",
  ComponentHeader: "#ffffff",
  iconColor: "#666666",
  headerIconColor: "#CCCCCC",
  headerBorderColor: "#636363",
  MapDrawingColor: "#898989",
  gridIconBorderColor: "#929292",
  ModalBGColor: "#FFFFFF",
  TextColor: "#000000",
  scrollThumbColor: "#CCCCCC;",
  HighlightColor: "#CDEEEA",
  ErrorMessageColor: "#E2445C",
  tooltipBGColor: "#EFEFEE",
  tooltipText: "#3E3E3E",
  tooltipBorderColor: "#7D7D7E",
  tooltipShadowColor: "#CBCBD1",
  menuHeaderBGColor: "#E6F6F4",
  gridTextColor: "#666666",
  rowViolationDotColor: "#D55A69",
  loadingBGColor: "#f7f7f7",
  gridBGColor: "#FFFFFF",
  terminalContentColor: "#000000",
  starIconColor: "#FFCA28",
  clickableLinkColor: "#B0E0E6",
  infoBGColor: "#C3DEDC",
  warningBGColor: "#FFECB3",
  errorBGColor: "#EF9A9A",
  infoTextColor: "#419081",
  warningTextColor: "#E65100",
  errorTextColor: "#9E0000",
  trailerBackgroundColor: "#F0F0F0",
  trailerBorderColor: "#ACADA9",
  recommendationCardStatusTextColor: "#8493A3",
  violationsTextColor: "#CF0000",
  popupLeftColColor: "#8493A3",
  subHeaderTextColor: "#525F6D",
  completeStopText: "#525F6D",
  stopsStatusBGColor: "#F7F8F9",
  errorBorderColor: "#f44336",
  inputWarningLabelColor: "#F3C03E",
  warningTextColorDispatch: "#D69900",
  gridGroupHeaderBorderColor: "#D9D9D9",
  dispatchPanelHeaderColor: "#666666",
  dispatchPanelLabelValueColor: "#444444",
  deviationStopPopupColor: "#E84259",
  actualRouteColor: "#666666",
  btnHoverColor: "#E0F2EF",
  disabledTextBG: "#F0F0F0",
  disabledGridRow : "#DBDBDB",
  KPI: {
    KPISingleValue: "#00A7E1",
    KPILabel: "#666666",
    KPIPositive: "#1ADE67",
    KPINegative: "#E95970",
    KPIGoalValue: "#848484",
    KPIDivider: "#E5E5E5",
  },
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#05A792",
    },
    secondary: {
      main: "#000000",
    },
  },
  routeMapColorPalette: {
    IconsColors: [
      "#C41A76",
      "#7220C8",
      "#00636C",
      "#B22811",
      "#FF7800",
      "#2B20AA",
      "#3C3B3B",
      "#DA75AC",
      "#A223D5",
      "#30B845",
      "#ED5146",
      "#44A8EE",
      "#099B95",
      "#82493F",
      "#FF288A",
      "#44BE9E",
      "#086DA7",
      "#E5A70D",
    ],
    MarkerBorderColor: "#FFFFFF",
    MarkerTextColor: "#FFFFFF",
  },
  AnchorBGColor: "#CDCDCD",
  AnchorTextColor: "#666666",
  SelectedStopBorderColor: "#FF0000",
  ToggleIconColor: "#01917E",
  lightPrimaryColor: "#D6F4EB",
  trailerCardSelectedColor: "#EBEBEB",
  messageTextColor: "#000000",
  sendMessageBGColor: "#e3e3e3",
  replyMessageBGColor: "#C0E3E2",
  ModalHeaderTextColor: "#8493A3",
  StatusWrapperColor: "#E0F2EF",
  ToggleDisableIconColor: "#979B9D",
  successTextColor: "#227270",
  chatBGColor: "#f6f6f6",
  dividerColor: "#E5E5E5",
  urgentColor: "#F2A93B",
  messageHistoryBGHoverColor: "#C0E3E2",
});

export const darkTheme = createMuiTheme({
  ...defaultThemeStyles,
  themeName: "dark",
  AppBGColor: "#11161C",
  HeaderBGColor: "#1D2630",
  HeaderSelectedText: "#05A792",
  HeaderDefaultTextColor: "#CDCDCD",
  ColumnHeaderTextColor: "#FFFFFF",
  ComponentHeader: "#1D2630",
  iconColor: "#808080",
  headerIconColor: "#808080",
  headerBorderColor: "#313840",
  MapDrawingColor: "#FFFFFF",
  gridIconBorderColor: "#7D7D7E",
  ModalBGColor: "#2C353E",
  TextColor: "#FFFFFF",
  scrollThumbColor: "#808080",
  HighlightColor: "#1B343A",
  ErrorMessageColor: "#E2445C",
  tooltipBGColor: "#2C3740",
  tooltipText: "#FFFFFF",
  tooltipBorderColor: "#CDCDCD",
  tooltipShadowColor: "#7D7D7E",
  menuHeaderBGColor: "#233D46",
  gridTextColor: "#CDCDCD",
  rowViolationDotColor: "#D55A69",
  loadingBGColor: "#11161C",
  gridBGColor: "#1D2630",
  terminalContentColor: "#FFFFFF",
  starIconColor: "#FFCA28",
  clickableLinkColor: "#B0E0E6",
  infoBGColor: "#C3DEDC",
  warningBGColor: "#FFECB3",
  errorBGColor: "#EF9A9A",
  infoTextColor: "#419081",
  warningTextColor: "#E65100",
  errorTextColor: "#9E0000",
  trailerBackgroundColor: "#11161C",
  trailerBorderColor: "#FFFFFF",
  recommendationCardStatusTextColor: "#8493A3",
  violationsTextColor: "#CF0000",
  popupLeftColColor: "#A3A3A3",
  subHeaderTextColor: "#FFFFFF",
  completeStopText: "#808080",
  stopsStatusBGColor: "transparent",
  successTextColor: "#227270",
  errorBorderColor: "#f44336",
  inputWarningLabelColor: "#F3C03E",
  warningTextColorDispatch: "#D69900",
  gridGroupHeaderBorderColor: "transparent",
  dispatchPanelHeaderColor: "#808080",
  dispatchPanelLabelValueColor: "#808080",
  deviationStopPopupColor: "#E53E4E",
  actualRouteColor: "#FFFFFF",
  btnHoverColor: "#E0F2EF",
  disabledTextBG: "#11161C",
  disabledGridRow : "rgb(235, 235, 228,0.4)",
  KPI: {
    KPISingleValue: "#00A7E1",
    KPILabel: "#9B9B9B",
    KPIPositive: "#1ADE67",
    KPINegative: "#E95970",
    KPIGoalValue: "#848484",
    KPIDivider: "#E5E5E5",
  },
  typography: {
    useNextVariants: true,
  },
  palette: {
    primary: {
      main: "#05A792",
    },
    secondary: {
      main: "#FFFFFF",
    },
  },
  routeMapColorPalette: {
    IconsColors: [
      "#FF9897",
      "#FFA640",
      "#FFE339",
      "#B9FF00",
      "#FFDBA3",
      "#0094B4",
      "#B1D7FF",
      "#A97BFF",
      "#FF7BEC",
      "#FF403B",
      "#B9FF00",
      "#00E7C3",
      "#98A8FF",
      "#E6B0FF",
      "#FF7F00",
      "#FF6562",
      "#19FF70",
    ],
    MarkerBorderColor: "#090F1E",
    MarkerTextColor: "#090F1E",
  },
  AnchorBGColor: "#CDCDCD",
  AnchorTextColor: "#090F1E",
  SelectedStopBorderColor: "#FF0000",
  ToggleIconColor: "#01917E",
  ToggleDisableIconColor: "#979B9D",
  lightPrimaryColor: "#D6F4EB",
  trailerCardSelectedColor: "#2F3740",
  messageTextColor: "#000000",
  sendMessageBGColor: "#e3e3e3",
  replyMessageBGColor: "#C0E3E2",
  ModalHeaderTextColor: "#8493A3",
  StatusWrapperColor: "#1D2630",
  chatBGColor: "#353E48",
  dividerColor: "#E5E5E5",
  urgentColor: "#F2A93B",
  messageHistoryBGHoverColor: "#11161C",
});
